import React from 'react';

import { CoreIcon } from '@aspid/ui';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import { IconCollection } from '@components/icons/iconCollection';

export const CookiesErrorContent: React.FC = () => {
  return (
    <Box sx={{ padding: 1 }}>
      <Typography variant="body1" gutterBottom>
        Для корректной работы сайта необходимо включить поддержку cookies в
        вашем браузере.
      </Typography>

      <Typography variant="body1" gutterBottom sx={{ mt: 2 }}>
        Как включить cookies:
      </Typography>

      <List>
        <ListItem>
          <ListItemIcon>
            <CoreIcon icon={IconCollection.done} color="primary" />
          </ListItemIcon>
          <ListItemText primary="Откройте настройки вашего браузера" />
        </ListItem>

        <ListItem>
          <ListItemIcon>
            <CoreIcon icon={IconCollection.done} color="primary" />
          </ListItemIcon>
          <ListItemText
            primary="Найдите раздел 'Конфиденциальность' или 'Приватность'" />
        </ListItem>

        <ListItem>
          <ListItemIcon>
            <CoreIcon icon={IconCollection.done} color="primary" />
          </ListItemIcon>
          <ListItemText
            primary="Разрешите использование cookies для этого сайта" />
        </ListItem>

        <ListItem>
          <ListItemIcon>
            <CoreIcon icon={IconCollection.done} color="primary" />
          </ListItemIcon>
          <ListItemText
            primary="Перезагрузите страницу после изменения настроек" />
        </ListItem>
      </List>

      <Box sx={{
        mt: 2,
        display: 'flex',
        alignItems: 'center',
        bgcolor: '#FFF4E5',
        p: 2,
        borderRadius: 1,
      }}>
        <CoreIcon icon={IconCollection.errorOutline} color="warning" sx={{ mr: 1 }} />
        <Typography variant="body2">
          Без поддержки cookies некоторые функции сайта будут недоступны,
          включая авторизацию и сохранение ваших настроек.
        </Typography>
      </Box>
    </Box>
  );
};
